import { useState } from 'react';
import queryString from 'query-string';
import moment from 'moment-timezone';
import { PayloadStates } from '@lore/utils';
import { useUser } from '@lore/auth';
import useStewardshipFilter from '@/pages/offers/useStewardshipFilter';
import { useConnect } from '@hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10 } = props;

  const currentUser = useUser();

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('offer.find', {
    where: {
      eager: {
        $where: {
          activityId: {
            $null: false
          },
          stars: {
            $where: {
              creatorId: currentUser.id
            }
          },
          createdAt: {
            $lte: timestamp
          },
          $or: stewardshipFilter
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    },
    // include: function(model) {
    //   return (
    //     model.id &&
    //     model.data.offerId &&
    //     model.data.creatorId === currentUser.id
    //   );
    // },
    exclude: function (model) {
      return model.state === PayloadStates.DELETED;
    }
  }, {
    keepPreviousData: true
  });
}